import { render, staticRenderFns } from "./SuggestAnalysisSamples.vue?vue&type=template&id=6f194e11"
import script from "./SuggestAnalysisSamples.vue?vue&type=script&lang=js"
export * from "./SuggestAnalysisSamples.vue?vue&type=script&lang=js"
import style0 from "./SuggestAnalysisSamples.vue?vue&type=style&index=0&id=6f194e11&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports